function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.8 11.5C0.8 8.35198 3.35198 5.8 6.5 5.8C9.64802 5.8 12.2 8.35198 12.2 11.5V13.2H0.8V11.5Z",
  stroke: "#C8C8C8",
  strokeWidth: 1.6
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 3.8,
  y: 7.2,
  width: 6.4,
  height: 5.4,
  rx: 2.7,
  transform: "rotate(-90 3.8 7.2)",
  fill: "white",
  stroke: "#C8C8C8",
  strokeWidth: 1.6
});

var SvgUsersIcon = function SvgUsersIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 13 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsersIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/users-icon.7f6c7920.svg";
export { ForwardRef as ReactComponent };